/* HF storefront behaviour — everything the 90KB product section cannot do
   from inside itself. Served as a cached asset rather than inlined into
   every page: it was 55KB of HTML on every request (2026-09-14, after a
   PageSpeed report showed FCP 5.9s / LCP 11.0s on mobile).

   Loaded with defer from layout/theme.liquid, so it still runs after the
   section's own inline scripts, exactly as it did when it lived inline.
   The two blocks that move things around before first paint — the pinned
   colour and the Add to Cart position — deliberately STAYED inline in
   theme.liquid, because running them after paint would shift the layout
   and the page currently scores CLS 0. Keep it that way. */
/* Scroll-preserving page lock (2026-09-14) — shared by the lightbox
   below and the cart drawer. Overlays used to freeze the page with
   overflow:hidden on <html>; iOS Safari can LOSE the scroll position
   when that lands, so after closing a photo zoom (or the drawer) the
   shopper found themselves at the TOP of the page — reported as "the
   page takes me to the top". The classic fix: pin <body> at
   position:fixed offset by the current scroll while the overlay is
   up, and put the scroll back on release. Reference-counted so the
   drawer opening over a lightbox can't unlock early. */
(function(){
  var y=0, n=0;
  window.hfLockPage=function(){
    if(++n>1) return;
    y=window.scrollY||document.documentElement.scrollTop||0;
    var b=document.body;
    b.style.position='fixed'; b.style.top=(-y)+'px';
    b.style.left='0'; b.style.right='0'; b.style.width='100%';
  };
  window.hfUnlockPage=function(){
    if(n<=0) return;
    if(--n>0) return;
    var b=document.body;
    b.style.position=''; b.style.top=''; b.style.left=''; b.style.right=''; b.style.width='';
    window.scrollTo(0,y);
  };
})();

/* Buy-box jump links.

   Several product-page CTAs point at "#hf-mp": the guarantee section's
   "Try Them Risk-Free" button and the doctor section's "Find Your Size".
   That element does not exist. hf-main-product renders its wrapper as
   hf-mp-<section id>, which resolves to a different id on every template
   (hf-mp-template--...__main), so the plain #hf-mp anchor never matched
   anything and both buttons silently did nothing on both product pages.

   Rather than edit that 90KB section, the link is resolved at click
   time. It aims at the add-to-cart form first, which is where the size
   picker and the Add to Cart button live, so the customer lands on the
   thing they actually need on desktop and mobile alike.

   Smooth scrolling is requested but never trusted: some browsers (and
   reduced-motion setups) ignore behavior:"smooth" on scrollIntoView and
   the page then does not move at all, which is exactly the dead button
   this is here to fix. So the landing position is re-checked afterwards
   and forced if the target is still off screen. */
(function(){
  function buyBox(){
    return document.querySelector('form[action*="/cart/add"]')
        || document.querySelector('[id^="hf-mp-"]')
        || document.querySelector('.hf-mp__form');
  }
  function land(t){
    var r = t.getBoundingClientRect();
    if (r.top >= 0 && r.top <= (window.innerHeight * 0.9)) return true;
    t.scrollIntoView({ block: 'center' });
    return false;
  }
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href="#hf-mp"]');
    if(!a) return;
    var t = buyBox();
    if(!t) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
    catch (err) { t.scrollIntoView(true); }
    setTimeout(function(){ land(t); }, 500);
    setTimeout(function(){
      land(t);
      var f = t.querySelector('select, input:not([type=hidden]), button');
      if (f && f.focus) { try { f.focus({ preventScroll: true }); } catch (err) {} }
    }, 900);
  }, true);
})();

/* Pin the Crisp chat launcher to the true bottom-right corner. The
   app carries a legacy vertical offset (set for the old theme's
   sticky bar); Crisp also re-applies its styles after load and on
   open/close, so this re-pins continuously rather than once. The
   already-pinned check keeps the style observer from looping. */
(function(){
  function pin(){
    var box=document.getElementById('crisp-chatbox');
    if(!box) return false;
    var els=[box].concat([].slice.call(box.querySelectorAll('a,div')));
    els.forEach(function(el){
      var s;
      try{ s=getComputedStyle(el); }catch(e){ return; }
      if(s.position!=='fixed') return;
      if(el.style.getPropertyValue('bottom')==='20px'&&el.style.getPropertyValue('right')==='20px'&&el.style.getPropertyValue('top')==='auto') return;
      el.style.setProperty('bottom','20px','important');
      el.style.setProperty('right','20px','important');
      el.style.setProperty('top','auto','important');
      el.style.setProperty('left','auto','important');
    });
    return true;
  }
  var t=setInterval(pin,1200);
  document.addEventListener('click',function(){ setTimeout(pin,300); },true);
  var boot=setInterval(function(){
    var box=document.getElementById('crisp-chatbox');
    if(box){
      clearInterval(boot);
      pin();
      try{ new MutationObserver(pin).observe(box,{attributes:true,subtree:true,attributeFilter:['style']}); }catch(e){}
    }
  },400);
  setTimeout(function(){ clearInterval(boot); },30000);
})();

/* Gallery image stamps. The product video that used to be injected
   into the image gallery was removed at the client's request
   (2026-09-14: "it's slowing down my load speed"), together with the
   phone carousel corrector that only existed to step the dots around
   that extra video slide. What remains is the stamp the desktop
   click-to-promote feature below relies on: every gallery img gets
   data-hfgi = its index at init, so a promotion can be unwound back
   into the original order on a colour change. */
(function(){
  var gal=document.querySelector('[data-mp-gal]');
  if(!gal) return;
  Array.prototype.forEach.call(gal.querySelectorAll('img'),function(im,i){ im.setAttribute('data-hfgi',String(i)); });
})();

/* Bundle pricing display (2026-09-09; .99 endings 2026-09-10). The
   real charging is done by two automatic discounts scoped to the
   single-pair product:
     "Buy 2 Pairs - $109.98 Bundle"  -$20.00 at 2+ pairs
     "Buy 3 Pairs - $149.97 Bundle"  -$45.00 at 3+ pairs
   (they don't combine, so Shopify applies the larger when both
   match; checkout is exact at every tier). The 90KB product section
   knows nothing about them: its bundle cards paint prices from a
   flat percent setting and its bundle total pill sums the pairs at
   full price, so the shopper used to see one set of numbers on the
   page and another in the cart. This corrector repaints those spots
   after every engine repaint (the engine paints synchronously
   inside its own click and change handlers, so a 0ms timeout
   always lands after it):
     - the bundle cards show PER-PAIR prices with .99 endings
       (client 2026-09-10: "remove one cent"): $54.99 and $49.99,
       struck against the product's per-pair compare-at, which is
       read live from the price row (2026-10-01; it was pinned at
       $220 with 75%/77% badges and went stale when the owner
       re-anchored to $99.99 — now 45%/50%). The discounts were retuned so the maths is EXACT:
       54.99 x 2 = 109.98 and 49.99 x 3 = 149.97, which is
       precisely what checkout charges;
     - in pair-picker mode the total pill shows the summed price
       minus the live discount for that pair count (parsed from the
       engine's own sum so a later price change stays consistent).
   The main price row's Save badge is deliberately NOT touched: the
   price element beside it always shows the single-pair $64.99 even
   in bundle mode, so the badge must stay the engine's own 70%
   (client 2026-09-10: a 75% override there "is not mathematically
   correct" against the visible price). The bundle percentages live
   on the bundle cards only.
   The dollar amounts are the source of truth from the discounts —
   if those discounts change, update D2/D3 here and the card labels.
   Scoped to the single-pair page: the BOGO page prices its own box
   and the discounts don't target the BOGO product. */
(function(){
  if(location.pathname.indexOf('/products/orthizen-comfort-2-0')!==0) return;
  if(location.pathname.indexOf('-bogo')>-1) return;
  /* D2 is a flat amount off the order at 2 pairs; D3 is PER PAIR from 3
     pairs up (owner, 2026-10-02). Both mirror the Shopify discounts
     exactly — "Buy 2 Pairs" -$20.00 on the order, "Buy 3+ Pairs -
     $49.99 per pair" -$15.00 on each item — so the pill and checkout
     agree at every quantity. Before this, D3 was a flat $45 like the
     discount it mirrored, and the price per pair CLIMBED above three
     pairs: five pairs cost $279.95 here and the same five bought as
     3+2 cost $259.95. */
  var D2=20.00, D3_PER_PAIR=15.00;
  var P2=54.99, P3=49.99;
  function put(sel,txt){ var el=document.querySelector(sel); if(el&&el.textContent!==txt) el.textContent=txt; }
  /* The struck price and the badge are READ from the product's live
     compare-at (2026-10-01) instead of being written out here. They were
     hard-coded to "$220.00" and 75%/77%, and when the owner moved the
     compare-at to $99.99 the cards kept advertising the old anchor while
     the price row beside them showed the new one. Derived, they follow any
     future change to the compare-at on their own. The per-pair prices stay
     fixed: those come from the two discounts, not from the anchor. */
  function wasPer(){
    var el=document.querySelector('[data-mp-was]');
    var n=el?parseFloat(String(el.textContent||'').replace(/[^0-9.]/g,'')):NaN;
    return (isFinite(n)&&n>0)?n:0;
  }
  function money(n){ return '$'+n.toFixed(2); }
  function pctOff(price,was){ return Math.round((1-(price/was))*100)+'%'; }
  function fix(){
    put('[data-mp-b2]',money(P2));
    put('[data-mp-b3]',money(P3));
    var was=wasPer();
    if(was>P2){
      put('[data-mp-b2was]',money(was)); put('[data-mp-b2sv]',pctOff(P2,was));
      put('[data-mp-b3was]',money(was)); put('[data-mp-b3sv]',pctOff(P3,was));
    }
    var pairsBox=document.querySelector('[data-mp-pairs]');
    if(!pairsBox||pairsBox.hidden) return;
    var list=document.querySelector('[data-mp-pairlist]');
    var n=list?list.children.length:0;
    if(n<2) return;
    var pill=document.querySelector('[data-mp-pill]');
    if(pill&&!(pill.dataset.hfbp&&pill.textContent===pill.dataset.hfbp)){
      var sum=Math.round(parseFloat((pill.textContent||'').replace(/[^0-9.]/g,''))*100);
      var disc=Math.round((n>=3 ? D3_PER_PAIR*n : D2)*100);
      if(sum>disc){
        var t='$'+((sum-disc)/100).toFixed(2);
        pill.textContent=t; pill.dataset.hfbp=t;
      }
    }
  }
  document.addEventListener('click',function(){ setTimeout(fix,0); });
  document.addEventListener('change',function(){ setTimeout(fix,0); });
  fix();
  document.addEventListener('DOMContentLoaded',fix);
  setTimeout(fix,400);
  setTimeout(fix,1200);
})();

/* Dead-click fixes (2026-09-10), driven by session recordings: on
   mobile, shoppers tap things that LOOK interactive and get no
   response - recorded as rapid repeat taps, then an exit.
     1. GALLERY PHOTOS: tapping a product photo did nothing. Now it
        opens a full-screen lightbox (tap anywhere or Escape to
        close; the CDN image is re-requested at 1600px so zooming
        is worth it). Applies to the main gallery photos and the
        customer-strip photos. Thumbnails keep their own behaviour.
        Since 2026-09-14 the lightbox locks the page with the
        scroll-preserving hfLockPage (top of this script) instead
        of overflow:hidden, which lost the scroll position on iOS.
     2. GALLERY VIDEO: tapping the clip now toggles play/pause.
     3. BOGO PAIR TILES: the two big "Buy One / Get One Free" tiles
        are pictures, but recordings show repeated taps on them.
        A tap now scrolls to that pair's picker row, flashes it,
        and opens the size dropdown when size is still unpicked.
     5. BOGO COLOUR + SIZE SHEET (2026-09-14): tapping a pair tile
        used to scroll to that pair's dropdown and try to pop it
        open with showPicker(), which iOS only supports from Safari
        17.4 — on an older iPhone the tap did nothing the shopper
        could see. A tap now opens a sheet holding that pair's
        gender, colours AND sizes, built from the real <select>
        options (and window.hfBgGender for the gender) so
        it can never drift from what the section rendered. Picking a
        colour leaves the sheet open (the shopper usually sets the
        size next, and the tiles behind repaint straight away);
        picking a size closes it. Either way the value is written
        back to the select and a bubbling 'change' is fired, which
        is what drives the section's own repaint, pricing and
        sold-out checks, and the picker row is flashed so the
        shopper can see what changed. It runs at every width — the
        merchant asked for a photo tap to re-offer the colours on
        desktop too — and hf-base.css centres it as a dialog above
        992px. An earlier version popped the Size Guide open after a
        size was chosen; the merchant found that interrupted the
        flow, so it does not.
     4. CLICK-TO-PROMOTE (2026-09-14, client wants the reference
        site's behaviour): on DESKTOP (>991px, where the gallery
        is a grid), clicking a grid photo SWAPS it with the main
        image instead of zooming - the clicked photo slides up
        into the hero slot and the old hero slides down into its
        place (FLIP transform animation). Clicking the hero photo
        still opens the zoom lightbox. Phones keep the carousel,
        where every photo tap zooms. The promotion swaps DOM
        positions inside the gallery; the data-hfgi stamps above
        record the original order. On a
        COLOUR change the engine re-assigns the hero by ORIGINAL
        order, so any promotion is unwound first: the imgs are put
        back in data-hfgi order, 30ms after the colour click, once
        the engine (sync) has run. */
(function(){
  var lb=null, lbImg=null;
  function closeLb(){
    if(lb&&lb.classList.contains('is-on')){
      lb.classList.remove('is-on'); lbImg.removeAttribute('src');
      if(window.hfUnlockPage) window.hfUnlockPage();
    }
  }
  function openLb(src){
    if(!lb){
      lb=document.createElement('div'); lb.className='hf-lightbox';
      lb.setAttribute('role','dialog'); lb.setAttribute('aria-label','Image zoom');
      lb.innerHTML='<button type="button" class="hf-lightbox__x" aria-label="Close">&times;</button><img alt="Zoomed product photo">';
      lbImg=lb.querySelector('img');
      lb.addEventListener('click',closeLb);
      document.body.appendChild(lb);
    }
    if(window.hfLockPage) window.hfLockPage();
    lbImg.src=src;
    lb.classList.add('is-on');
  }
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeLb(); closeSheet(); } });
  function bigSrc(img){
    var u=img.currentSrc||img.src||'';
    if(/([?&])width=\d+/.test(u)) return u.replace(/([?&])width=\d+/,'$1width=1600');
    return u;
  }
  function flip(el,from){
    var to=el.getBoundingClientRect();
    var dx=from.left-to.left, dy=from.top-to.top;
    var sx=to.width>0?from.width/to.width:1, sy=to.height>0?from.height/to.height:1;
    el.style.transformOrigin='top left';
    el.style.transition='none';
    el.style.transform='translate('+dx+'px,'+dy+'px) scale('+sx+','+sy+')';
    el.style.zIndex='2';
    requestAnimationFrame(function(){
      el.style.transition='transform .45s ease';
      el.style.transform='';
    });
    setTimeout(function(){
      el.style.transition=''; el.style.transform=''; el.style.transformOrigin=''; el.style.zIndex='';
    },520);
  }
  /* Phone-only size sheet for the BOGO pair tiles. Built once, refilled
     per pair from that pair's real <select>, so sizes and their order
     always match what the section rendered. */
  var sheet=null, sheetSel=null, sheetCsel=null, sheetPair=null;
  /* Photo for each colourway in the sheet (2026-09-14). The client wants
     the colour being chosen to be visible in the popup, not just named.
     Same source the section uses for the tiles: the first variant image
     of each colour, from this product's public JSON. Declared HERE, in
     the same IIFE as the sheet — theme.liquid's blocks are separate
     closures and an earlier attempt from the BOGO block threw
     "colourImg is not defined" and stopped the sheet opening at all.
     Stays text-only if the fetch has not landed or fails; the sheet
     never waits on it. */
  var colourImg=null;
  if(document.querySelector('[data-bg-wrap]')){
    fetch(location.pathname.split('?')[0]+'.js')
      .then(function(r){ return r.ok?r.json():null; })
      .then(function(p){
        if(!p||!p.variants) return;
        var m={};
        p.variants.forEach(function(v){
          var c=v.option1;
          if(c&&!m[c]&&v.featured_image&&v.featured_image.src) m[c]=v.featured_image.src;
        });
        colourImg=m;
      }).catch(function(){});
  }
  function closeSheet(){
    if(!sheet||!sheet.classList.contains('is-on')) return;
    sheet.classList.remove('is-on');
    sheetSel=null; sheetCsel=null; sheetPair=null;
    if(window.hfUnlockPage) window.hfUnlockPage();
  }
  function buildSheet(){
    sheet=document.createElement('div');
    sheet.className='hf-sizesheet';
    sheet.innerHTML='<div class="hf-sizesheet__bk" data-ss-close></div>'
      +'<div class="hf-sizesheet__panel" role="dialog" aria-modal="true" aria-label="Choose colour and size">'
      +'<div class="hf-sizesheet__head"><b data-ss-title>Choose colour and size</b>'
      +'<button type="button" class="hf-sizesheet__x" data-ss-close aria-label="Close">&times;</button></div>'
      +'<div class="hf-sizesheet__body">'
      +'<div class="hf-sizesheet__group" data-ss-ggroup><p class="hf-sizesheet__glab">Gender</p>'
      +'<div class="hf-sizesheet__genders" data-ss-genders></div></div>'
      +'<div class="hf-sizesheet__group" data-ss-cgroup><p class="hf-sizesheet__glab">Colour</p>'
      +'<div class="hf-sizesheet__colours" data-ss-colours></div></div>'
      +'<div class="hf-sizesheet__group"><p class="hf-sizesheet__glab">Size</p>'
      +'<div class="hf-sizesheet__list" data-ss-list></div></div>'
      +'</div></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click',function(ev){
      if(ev.target.closest('[data-ss-close]')){ closeSheet(); return; }
      /* Gender only relabels this pair's sizes — same variants, so the
         sheet stays open and any chosen size stays chosen. */
      var gen=ev.target.closest('[data-ss-gender]');
      if(gen&&window.hfBgGender&&sheetPair){
        window.hfBgGender.set(sheetPair, gen.getAttribute('data-ss-gender'));
        Array.prototype.forEach.call(sheet.querySelectorAll('[data-ss-gender]'),function(x){
          x.classList.toggle('is-on',x===gen);
        });
        syncSizeLabels();
        return;
      }
      /* A colour keeps the sheet open: the shopper usually wants to set
         the size straight after, and the tiles behind repaint anyway. */
      var col=ev.target.closest('[data-ss-col]');
      if(col&&sheetCsel){
        sheetCsel.value=col.getAttribute('data-ss-col');
        sheetCsel.dispatchEvent(new Event('change',{bubbles:true}));
        Array.prototype.forEach.call(sheet.querySelectorAll('[data-ss-col]'),function(x){
          x.classList.toggle('is-on',x===col);
        });
        return;
      }
      var opt=ev.target.closest('[data-ss-val]');
      if(!opt||!sheetSel) return;
      var sel=sheetSel;
      sel.value=opt.getAttribute('data-ss-val');
      sel.dispatchEvent(new Event('change',{bubbles:true}));
      var row=sel.closest('.hf-mp__bgrow')||sel;
      row.classList.add('hf-mp__choose-flash');
      setTimeout(function(){ row.classList.remove('hf-mp__choose-flash'); },1400);
      closeSheet();
    });
  }
  function syncSizeLabels(){
    if(!sheet||!sheetSel) return;
    Array.prototype.forEach.call(sheet.querySelectorAll('[data-ss-val]'),function(b){
      var v=b.getAttribute('data-ss-val'), txt=null;
      Array.prototype.forEach.call(sheetSel.options,function(o){ if(o.value===v) txt=o.textContent; });
      if(txt) b.textContent=txt;
    });
  }
  function openSizeSheet(sel,pairNo){
    if(!sheet) buildSheet();
    sheetSel=sel;
    sheetPair=String(pairNo);
    sheet.querySelector('[data-ss-title]').textContent='Pair '+pairNo+' \u2014 gender, colour & size';
    var ggroup=sheet.querySelector('[data-ss-ggroup]');
    var gbox=sheet.querySelector('[data-ss-genders]');
    gbox.innerHTML='';
    if(window.hfBgGender){
      ggroup.hidden=false;
      [['w','Women'],['m','Men']].forEach(function(pair){
        var b=document.createElement('button');
        b.type='button';
        b.className='hf-sizesheet__gender'+(window.hfBgGender.get(sheetPair)===pair[0]?' is-on':'');
        b.setAttribute('data-ss-gender',pair[0]);
        b.textContent=pair[1];
        gbox.appendChild(b);
      });
    } else { ggroup.hidden=true; }
    var csel=document.querySelector('select[data-bg-c="'+pairNo+'"]');
    var cgroup=sheet.querySelector('[data-ss-cgroup]');
    var cbox=sheet.querySelector('[data-ss-colours]');
    cbox.innerHTML='';
    sheetCsel=csel||null;
    cgroup.hidden=!(csel&&csel.options.length>1);
    if(csel){
      Array.prototype.forEach.call(csel.options,function(o){
        if(!o.value) return;
        var b=document.createElement('button');
        b.type='button';
        b.className='hf-sizesheet__col'+(o.value===csel.value?' is-on':'');
        b.setAttribute('data-ss-col',o.value);
        var src=colourImg&&colourImg[o.value];
        if(src){
          var im=document.createElement('img');
          im.src=src+(src.indexOf('?')>-1?'&':'?')+'width=160';
          im.alt='';
          /* eager on purpose: the sheet is display:none until it opens,
             and a lazy image inside a hidden box never fetches — it then
             stays blank even after the sheet is shown. Four 160px
             thumbnails, built only when the sheet is opened. */
          b.appendChild(im);
        }
        var sp=document.createElement('span');
        sp.textContent=o.textContent;
        b.appendChild(sp);
        cbox.appendChild(b);
      });
    }
    var list=sheet.querySelector('[data-ss-list]');
    list.innerHTML='';
    Array.prototype.forEach.call(sel.options,function(o){
      if(!o.value) return;
      var b=document.createElement('button');
      b.type='button';
      b.className='hf-sizesheet__opt'+(o.value===sel.value?' is-on':'')+(o.disabled?' is-off':'');
      b.setAttribute('data-ss-val',o.value);
      if(o.disabled) b.disabled=true;
      b.textContent=o.textContent;
      list.appendChild(b);
    });
    if(window.hfLockPage) window.hfLockPage();
    sheet.classList.add('is-on');
  }
  var promoted=false;
  function promote(gal,img){
    var hero=gal.querySelector('img.is-hero');
    if(!hero||hero===img) return false;
    var hFrom=hero.getBoundingClientRect(), iFrom=img.getBoundingClientRect();
    var ph=document.createElement('span');
    gal.insertBefore(ph,img);
    gal.insertBefore(img,hero);
    gal.insertBefore(hero,ph);
    ph.remove();
    hero.classList.remove('is-hero');
    img.classList.add('is-hero');
    flip(hero,hFrom);
    flip(img,iFrom);
    promoted=true;
    return true;
  }
  function restoreOrder(){
    if(!promoted) return;
    promoted=false;
    var gal=document.querySelector('[data-mp-gal]');
    if(!gal) return;
    var imgs=[].slice.call(gal.querySelectorAll('img[data-hfgi]'))
      .sort(function(a,b){ return parseInt(a.getAttribute('data-hfgi'),10)-parseInt(b.getAttribute('data-hfgi'),10); });
    imgs.forEach(function(im){ gal.appendChild(im); });
  }
  document.addEventListener('click',function(e){
    if(e.target.closest&&e.target.closest('[data-mp-opt="0"]')) setTimeout(restoreOrder,30);
  });
  document.addEventListener('change',function(e){
    if(!e.target.closest) return;
    if(e.target.closest('[data-bg-c]')||e.target.closest('select[data-mp-stopt="0"]')) setTimeout(restoreOrder,30);
  });
  document.addEventListener('click',function(e){
    if(!e.target.closest) return;
    var img=e.target.closest('[data-mp-gal] img, .hf-mp__ugctrack img');
    if(img){
      var gal=img.closest('[data-mp-gal]');
      if(gal && window.innerWidth>991 && !img.classList.contains('is-hero')){
        if(promote(gal,img)) return;
      }
      openLb(bigSrc(img));
      return;
    }
    var tile=e.target.closest('[data-bg-wrap] .hf-mp__bgtile');
    if(tile){
      var idx=tile.querySelector('[data-bg-img="2"]')?'2':'1';
      var sel=document.querySelector('select[data-bg-s="'+idx+'"]');
      if(!sel) return;
      openSizeSheet(sel,idx);
    }
  });
})();

/* BOGO sells the real product (2026-09-11). The two-pair offer page
   used to add a SEPARATE "BOGO" product to the cart - one line, one
   phantom SKU - so those orders never touched the real Comfort 2.0
   product: its inventory did not move and the team saw a second
   product to track. This interceptor takes over the page's Add Both
   Pairs button at CAPTURE phase (the section's own handler, which
   adds the shell product, never fires) and instead:
     1. resolves BOTH chosen pairs against the REAL single-pair
        product's variants (same colour/size option values);
     2. applies the BUY1GET1FREE discount code (main product, $29.99
        off at 2+ pairs: 2 x $64.99 - $29.99 = exactly $99.99; it
        does not combine with the bundle automatics, and Shopify
        grants whichever is better - this code at 2 pairs, the
        $45-off automatic at 3+);
     3. adds the two real variants as two labelled lines ("Pair 1
        of 2" / "Pair 2 of 2" + the offer name), so the warehouse
        reads the order the same way it always did.
   The page itself - URL, layout, $99.99 price display - is
   unchanged; the shell product remains ONLY as the holder of the
   /products/orthizen-comfort-2-0-bogo URL and is never added to a
   cart from anywhere (the /cart upsell was repointed too). Verified
   live: the code shows in cart and drawer, total exactly $99.99.
   If the code or the offer maths ever changes, update CODE here and
   the discount together. */
(function(){
  if(location.pathname.indexOf('/products/orthizen-comfort-2-0-bogo')!==0) return;
  var wrap=document.querySelector('[data-bg-wrap]');
  if(!wrap) return;
  /* Keep the two tile photos small (2026-09-14). The section paints them
     from the variant's raw featured_image — a 2048px PNG dropped into a
     170px tile, downloaded again on every colour change. Its Liquid does
     ask for width:400 for the first paint, so only the JS repaint is at
     fault. Rather than let the big file start downloading and swap it
     afterwards, the src SETTER on those two <img> elements is wrapped so
     every assignment is rewritten with a width cap before the browser
     ever sees it. Falls through untouched if the property cannot be
     redefined. */
  (function(){
    var W=400;
    function cap(u){
      u=String(u||'');
      if(!u) return u;
      if(/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/,'$1width='+W);
      return u+(u.indexOf('?')>-1?'&':'?')+'width='+W;
    }
    var d=Object.getOwnPropertyDescriptor(HTMLImageElement.prototype,'src');
    Array.prototype.forEach.call(document.querySelectorAll('[data-bg-img]'),function(img){
      /* The first src already comes from Liquid at width:400, so it is
         left alone — only the JS repaints need capping. These two are
         also switched off lazy loading: swapping the src of an image
         that is still waiting to lazy-load leaves it stalled in Chrome
         (seen here — the tiles stayed blank), and at 400px inside the
         offer box they are cheap to fetch up front. */
      img.loading='eager';
      if(d&&d.set&&d.get){
        try{
          Object.defineProperty(img,'src',{
            configurable:true,
            get:function(){ return d.get.call(this); },
            set:function(v){ d.set.call(this,cap(v)); }
          });
        }catch(e){}
      }
    });
  })();
  /* Open on the two colourways the merchant wants on show (2026-09-14).
     The section picks pair 1 from the LAST colour and pair 2 from the
     FIRST, which lands on Grey + Black. Setting the value and firing the
     section's own 'change' repaints the tile photos, the colour names
     under them, the gallery filter and the sold-out check, so none of
     that logic is duplicated here. Silently leaves a pair alone if the
     colour is ever renamed or dropped from the product. */
  (function(){
    var want={'1':'Black & White','2':'Grey'};
    ['1','2'].forEach(function(n){
      var sel=document.querySelector('select[data-bg-c="'+n+'"]');
      if(!sel) return;
      var v=want[n];
      var ok=Array.prototype.some.call(sel.options,function(o){ return o.value===v; });
      if(!ok||sel.value===v) return;
      sel.value=v;
      sel.dispatchEvent(new Event('change',{bubbles:true}));
    });
    /* And a size on both pairs (2026-09-14). The merchant wants the offer
       ready to buy the moment the page opens, so Add to Cart is live
       without a choice being made — the same W 8.5 / M 7 the single-pair
       page is pinned to. Firing the section's own change event is what
       takes the button out of its disabled state, because that is where it
       re-checks the pair. A size the shopper already picked is never
       overwritten. */
    ['1','2'].forEach(function(n){
      var sel=document.querySelector('select[data-bg-s="'+n+'"]');
      if(!sel||sel.value) return;
      var v='Women 8.5 - Men 7';
      var ok=Array.prototype.some.call(sel.options,function(o){ return o.value===v; });
      if(!ok) return;
      sel.value=v;
      sel.dispatchEvent(new Event('change',{bubbles:true}));
    });
  })();
  /* Per-pair Women / Men (2026-09-14, replacing a single toggle).
     The first version put ONE Women/Men tab above both rows, which
     quietly locked the two pairs to the same gender — a customer
     could not order a men's pair and a women's pair together
     (client). Each pair now carries its own gender select, in the
     same Gender / Colour / Size order the single-pair page uses for
     its multi-pair picker. Only the size LABELS follow it: every
     option keeps its full "Women 8.5 - Men 7" value, so the
     section's variant lookup, the cart interceptor and a size
     already chosen are all untouched. The state is published on
     window.hfBgGender because the photo popup lives in a different
     IIFE in this file and has to drive the same thing — these
     blocks are separate closures and share nothing otherwise.
     Skipped entirely unless the sizes are dual labels. */
  (function(){
    var s1=document.querySelector('select[data-bg-s="1"]');
    if(!s1) return;
    var dual=Array.prototype.some.call(s1.options,function(o){
      return o.value && /women/i.test(o.value) && /men/i.test(o.value);
    });
    if(!dual) return;
    var view={'1':'w','2':'w'};
    function half(val,v){
      var parts=String(val).split(' - ');
      var w=(parts[0]||'').trim().replace(/^women\s*/i,'W ');
      var m=(parts[1]||'').trim().replace(/^men\s*/i,'M ');
      return (v==='m'?m:w)||val;
    }
    function relabel(n){
      var sel=document.querySelector('select[data-bg-s="'+n+'"]');
      if(!sel) return;
      Array.prototype.forEach.call(sel.options,function(o){
        if(o.value) o.textContent=half(o.value,view[n]);
      });
    }
    function setGender(n,v){
      n=String(n); v=(v==='m')?'m':'w';
      if(!(n in view)) return;
      view[n]=v;
      var g=document.querySelector('select[data-hf-bgg="'+n+'"]');
      if(g&&g.value!==v) g.value=v;
      relabel(n);
    }
    ['1','2'].forEach(function(n){
      var sel=document.querySelector('select[data-bg-s="'+n+'"]');
      if(!sel) return;
      var row=sel.closest('.hf-mp__bgrow')||sel.parentNode;
      var g=document.createElement('select');
      g.setAttribute('data-hf-bgg',n);
      g.setAttribute('aria-label','Pair '+n+' gender');
      var ow=document.createElement('option'); ow.value='w'; ow.textContent='Women';
      var om=document.createElement('option'); om.value='m'; om.textContent='Men';
      g.appendChild(ow); g.appendChild(om);
      var colour=row.querySelector('select[data-bg-c]');
      row.insertBefore(g, colour||sel);
      g.addEventListener('change',function(){ setGender(n,g.value); });
      relabel(n);
    });
    window.hfBgGender={ get:function(n){ return view[String(n)]||'w'; }, set:setGender };
  })();

  /* Sticky Add to Cart for the BOGO page (2026-09-14). The section
     builds one for the single-pair page but deliberately skips it here
     (an "unless bogo_on" guard), so this is a bar of
     its own: same shape, same bottom-of-screen position the client
     asked for, and it drives the page's real Add To Cart rather than
     duplicating the add logic. It stays out of the way while the real
     button is on screen and appears once that has scrolled past. If a
     size is still missing it takes the shopper back to the box and
     flashes it instead of firing an add that would only surface an
     error they cannot see from down here. */
  (function(){
    var realAtc=document.querySelector('[data-bg-atc]');
    if(!realAtc) return;
    var bar=document.createElement('div');
    bar.className='hf-bgsticky';
    bar.setAttribute('aria-hidden','true');
    var thumb=document.querySelector('[data-bg-img="1"]');
    var titleEl=document.querySelector('.hf-mp__title');
    var html='<div class="hf-bgsticky__in">';
    if(thumb) html+='<img alt="" src="'+thumb.getAttribute('src')+'">';
    html+='<span class="hf-bgsticky__t"></span>'
       +'<span class="hf-bgsticky__p" data-bgst-price></span>'
       +'<button type="button" class="hf-bgsticky__atc">Add to Cart</button></div>';
    bar.innerHTML=html;
    bar.querySelector('.hf-bgsticky__t').textContent=(titleEl?titleEl.textContent:document.title).replace(/\s+/g,' ').trim();
    document.body.appendChild(bar);
    /* Thumbnail follows pair 1's colour (client 2026-09-14). The section
       repaints pair 1's photo inside its own change handler; the timeout
       reads it after that has run. */
    var barImg=bar.querySelector('img');
    document.addEventListener('change',function(e){
      if(!barImg||!e.target.closest||!e.target.closest('[data-bg-c="1"]')) return;
      setTimeout(function(){
        var t=document.querySelector('[data-bg-img="1"]');
        if(t&&t.getAttribute('src')) barImg.setAttribute('src',t.getAttribute('src'));
      },0);
    });
    function syncPrice(){
      var pill=realAtc.querySelector('[data-mp-pill]');
      var was=realAtc.querySelector('.hf-mp__atcp s');
      var out='';
      if(was&&!was.hidden&&was.textContent) out+='<s>'+was.textContent+'</s>';
      if(pill) out+=pill.textContent;
      bar.querySelector('[data-bgst-price]').innerHTML=out;
    }
    function sized(){
      var a=document.querySelector('select[data-bg-s="1"]'), b=document.querySelector('select[data-bg-s="2"]');
      return !!(a&&a.value&&b&&b.value);
    }
    bar.querySelector('.hf-bgsticky__atc').addEventListener('click',function(){
      if(sized()){ realAtc.click(); return; }
      var box=document.querySelector('[data-bg-wrap]');
      if(box){
        box.scrollIntoView({block:'center',behavior:'smooth'});
        var row=document.querySelector('select[data-bg-s="1"]');
        row=(row&&row.closest('.hf-mp__bgrow'))||box;
        row.classList.add('hf-mp__choose-flash');
        setTimeout(function(){ row.classList.remove('hf-mp__choose-flash'); },1600);
      }
    });
    var realVisible=true;
    function paint(){
      var show=!realVisible && window.scrollY>300;
      bar.classList.toggle('is-on',show);
      bar.setAttribute('aria-hidden',show?'false':'true');
    }
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){ realVisible=e.isIntersecting; });
        paint();
      },{threshold:0}).observe(realAtc);
    } else { realVisible=false; }
    window.addEventListener('scroll',paint,{passive:true});
    document.addEventListener('click',function(){ setTimeout(syncPrice,0); });
    document.addEventListener('change',function(){ setTimeout(syncPrice,0); });
    syncPrice(); paint();
  })();

  var CODE='BUY1GET1FREE';
  var mainP=null, loading=null;
  function loadMain(){
    if(mainP) return Promise.resolve(mainP);
    if(loading) return loading;
    loading=fetch('/products/orthizen-comfort-2-0.js')
      .then(function(r){ if(!r.ok) throw new Error('main product fetch failed'); return r.json(); })
      .then(function(p){ mainP=p; return p; })
      .catch(function(e){ loading=null; throw e; });
    return loading;
  }
  loadMain().catch(function(){});
  function findV(p,color,size){
    for(var i=0;i<p.variants.length;i++){
      if(p.variants[i].option1===color && p.variants[i].option2===size) return p.variants[i];
    }
    return null;
  }
  function val(sel){ var el=document.querySelector(sel); return el?el.value:''; }
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-bg-atc]');
    if(!btn) return;
    e.stopPropagation();
    e.preventDefault();
    var berr=document.querySelector('[data-bg-err]');
    function fail(m){ if(berr){ berr.textContent=m; berr.classList.add('is-on'); } btn.disabled=false; }
    var c1=val('[data-bg-c="1"]'), s1=val('[data-bg-s="1"]');
    var c2=val('[data-bg-c="2"]'), s2=val('[data-bg-s="2"]');
    if(!(s1&&s2)){ fail('Please select a size for both pairs.'); return; }
    if(berr) berr.classList.remove('is-on');
    btn.disabled=true;
    var D=window.HFCartDrawer;
    /* Speed (2026-09-15). The code used to be applied by loading the
       /discount/CODE page, a full page render measured at ~2.6s, before the
       add even started. It now goes through the Ajax cart (update.js with
       "discount", ~1.1s, same result: total exactly $99.99), and the drawer
       opens with its spinner the moment the button is pressed. The old page
       request is kept only as a fallback if the Ajax call is refused. */
    var items;
    if(D&&D.add){ D.open(); D.loading(true); }
    function stopLoading(){ if(D&&D.loading) D.loading(false); }
    loadMain().then(function(p){
      var v1=findV(p,c1,s1), v2=findV(p,c2,s2);
      if(!v1||!v1.available){ stopLoading(); if(D) D.close(); fail('Pair 1: that size is sold out - try another.'); return; }
      if(!v2||!v2.available){ stopLoading(); if(D) D.close(); fail('Pair 2: that size is sold out - try another.'); return; }
      items=[
        {id:v1.id,quantity:1,properties:{'BOGO Offer':'2 Pairs, Save $90','Pair':'1 of 2'}},
        {id:v2.id,quantity:1,properties:{'BOGO Offer':'2 Pairs, Save $90','Pair':'2 of 2'}}
      ];
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:CODE})})
        .then(function(r){ if(!r.ok) throw new Error('discount via ajax refused'); })
        .catch(function(){ return fetch('/discount/'+CODE).catch(function(){}); })
        .then(function(){
          if(D&&D.add){ return D.add({items:items}).then(function(){ btn.disabled=false; }); }
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
            .then(function(r){ if(!r.ok) throw new Error('add failed'); window.location.href='/cart'; });
        });
    }).catch(function(){ stopLoading(); fail('Could not add to cart - please try again.'); });
  }, true);
})();

/* Guarantee + rating, one line under the price (2026-10-01, owner request;
   rating added, then raised to 4.9 and merged onto a single row; back to
   4.8 on 2026-10-26, when the owner asked for one rating everywhere and
   chose the figure Loox actually shows further down the same page). The
   section has no slot for either: its benefit list renders further down
   the buy column, which on a phone sits BELOW the gallery, and the owner
   wants both beside the price.

   Anchored AFTER .hf-mp__head (title + price), never inside it, and
   positioned relative to whatever head's parent is at the time:
     - phone  head is in .hf-mp__mintro, so the row lands under the price
              and above the gallery, which is where it was asked for;
     - desktop an inline mover in theme.liquid has already lifted head out
              of mintro (which is display:none there) into .hf-mp__buy, so
              it follows head into the right-hand column.
   Inside head it would NOT work: head is a flex ROW above 991px, so the
   row sat in a third column beside the price and wrapped.

   The stars are SVG, not text glyphs: the last filled star is painted from
   a two-stop gradient whose stops meet at the exact fraction RATING leaves
   over, so a part-filled star is precise at any size. A clipped "★★★★★"
   string would drift with font metrics and letter-spacing. RATING is the
   single source of truth for the number AND the fill, so changing it alone
   keeps the two honest with each other. Styled in hf-base.css, where the
   row is allowed to wrap: on screens under ~370px the two halves need more
   width than there is, and wrapping beats overflowing. */
(function(){
  /* Product pages, plus the heel landing page, where the owner asked for
     the same one-liner in place of the section's "4.9 Rating (51,233+
     Reviews)" line (2026-10-01). Keyed off the path the way the bundle and
     BOGO correctors above are; the landing section takes no setting for
     this and is 73KB, so it is not edited from the API. */
  var LP = location.pathname.indexOf('/pages/heel-relief-shoes')===0;
  var PDP = document.body && document.body.className.indexOf('template-product')>=0;
  if(!PDP && !LP) return;
  var TXT='45 Days Money Back Guarantee';
  /* loox_count_v1 (owner, 2026-11-03: "After 4.8 Ratings - Please number of Reviews we have in
     LOOX right now. Show the correct number of loox reviews right now.")
     Both figures are READ OFF THE PAGE rather than written here. The section already prints this
     product's own Loox record server-side - the loox.num_reviews / loox.avg_rating metafields -
     into .hf-mp__stars--big, a row hf-base.css hides on product pages (owner, 2026-10-01) in
     favour of this one. Reading them from there makes them per product and keeps them in step
     with the Loox wall further down the SAME page, which is the standing rule (2026-10-26: the
     headline must never claim more than Loox shows - the reason 4.9 was dropped for 4.8).
     FALLBACK covers the two cases where there is no such row: a product Loox has no reviews for,
     and the landing page, which has no product at all. */
  var FALLBACK=4.8;
  function looxRow(){
    var row=document.querySelector('.hf-mp__stars--big');
    if(!row) return null;
    var out={avg:null,n:0}, lk=row.querySelector('[data-mp-revlink]'), m, i;
    if(lk){ m=(lk.textContent||'').match(/\d+/); if(m) out.n=parseInt(m[0],10); }
    /* The rating sits in the only SPAN with no class of its own ("Excellent 4.7"); .st carries the
       stars and .hf-mp__starsep the divider. Matched that way rather than by position, so a tweak
       to the row's markup degrades to the fallback instead of printing a star count as a rating. */
    for(i=0;i<row.children.length;i++){
      if(row.children[i].tagName!=='SPAN' || row.children[i].className) continue;
      m=(row.children[i].textContent||'').match(/\d+(?:\.\d+)?/);
      if(m){ out.avg=parseFloat(m[0]); break; }
    }
    return (out.n || out.avg!==null) ? out : null;
  }
  var LOOX=looxRow();
  var RATING=(LOOX && LOOX.avg) ? LOOX.avg : FALLBACK;
  var NREV=LOOX ? LOOX.n : 0;
  var STAR='M12 2l2.9 6.3 6.8.8-5 4.7 1.3 6.8L12 17.3 5.9 20.6 7.2 13.8 2.2 9.1l6.8-.8z';
  /* Literal hex, not CSS variables: var() is not resolved inside an SVG
     presentation attribute, so fill="var(--x)" paints nothing. ON is the
     same yellow the ticker headline uses (#ebbf20). */
  var ON='#ebbf20', OFF='#dfe3da';
  function svg(fill){
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+STAR+'" fill="'+fill+'"/></svg>';
  }
  function stars(){
    var full=Math.floor(RATING), frac=RATING-full, out='';
    if(frac>=0.05){
      var at=Math.round(frac*100)+'%';
      out+='<svg width="0" height="0" aria-hidden="true" focusable="false" class="hf-mp__rdef">'
        +'<defs><linearGradient id="hfPartStar"><stop offset="'+at+'" stop-color="'+ON+'"/>'
        +'<stop offset="'+at+'" stop-color="'+OFF+'"/></linearGradient></defs></svg>';
    }
    for(var i=0;i<full;i++) out+=svg(ON);
    if(frac>=0.05) out+=svg('url(#hfPartStar)');
    for(var j=full+(frac>=0.05?1:0);j<5;j++) out+=svg(OFF);
    return out;
  }
  function buildGtee(){
    var el=document.createElement('span');
    el.className='hf-mp__gtee';
    el.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true">'
      +'<path d="M12 2.5 20 6v6c0 4.6-3.2 8.3-8 9.5-4.8-1.2-8-4.9-8-9.5V6z"/>'
      +'<polyline points="8.4 12.2 10.9 14.7 15.7 9.6"/></svg><span></span>';
    el.querySelector('span').textContent=TXT;
    return el;
  }
  function buildRate(){
    var el=document.createElement('span');
    el.className='hf-mp__rate';
    el.setAttribute('aria-label','Rated '+RATING+' out of 5'+(NREV?' from '+NREV+' reviews':''));
    el.innerHTML='<span class="hf-mp__rstars" aria-hidden="true">'+stars()+'</span><b></b>';
    el.querySelector('b').textContent=String(RATING);
    /* loox_count_v1: the count follows the rating, and links to the review wall exactly as the
       hidden row it replaces did. Left off entirely when Loox has none, rather than printing a
       zero. */
    if(NREV){
      var a=document.createElement('a');
      a.className='hf-mp__rcount';
      a.href='#looxReviews';
      a.textContent='('+NREV+(NREV===1?' Review':' Reviews')+')';
      el.appendChild(a);
    }
    return el;
  }
  function buildLine(){
    var w=document.createElement('div');
    w.className='hf-mp__tline';
    w.appendChild(buildGtee());
    w.appendChild(buildRate());
    return w;
  }
  function add(){
    if(LP){
      if(document.querySelector('.hf-mp__tline')) return;
      /* ABOVE the title (owner, 2026-10-01), not under the price where it
         first went. Measured on the draft: once its text setting is
         cleared the section drops .lpb__rating altogether rather than
         leaving the stars behind, so there is normally nothing of the old
         line left; it is removed anyway in case the setting is ever put
         back, so the two can never both show. */
      var old=document.querySelector('.lpb__rating');
      if(old && old.parentNode) old.parentNode.removeChild(old);
      var title=document.querySelector('.lpb__title');
      if(!title) return;
      var line=buildLine();
      line.className='hf-mp__tline hf-mp__tline--top';
      title.parentNode.insertBefore(line, title);
      return;
    }
    var head=document.querySelector('.hf-mp__head');
    if(!head) return;
    /* Under the PRICE (owner, 2026-10-01, after a pass above the title).
       On phones the row is put INSIDE head, straight after the price box,
       so its position is tied to the price element itself rather than to
       wherever head happens to sit among its siblings — the section moves
       head between .hf-mp__mintro and .hf-mp__buy depending on the width
       at page load, and anchoring to a sibling made the row land below the
       gallery in some states. head stacks as a column under 991px, so a
       third child falls neatly below the price.
       Above 991px head is a flex ROW (title | price): a child there would
       become a third column and squash the heading, so the row goes after
       head instead, which reads as under the title block. Re-evaluated on
       resize because the breakpoint can be crossed after load. */
    var line=document.querySelector('.hf-mp__tline') || buildLine();
    var price=head.querySelector('.hf-mp__pricebox');
    var narrow=window.matchMedia && window.matchMedia('(max-width:991px)').matches;
    if(narrow && price){
      if(price.nextElementSibling!==line) head.insertBefore(line, price.nextSibling);
    } else {
      if(head.nextElementSibling!==line) head.parentNode.insertBefore(line, head.nextSibling);
    }
  }
  add();
  document.addEventListener('DOMContentLoaded',add);
  document.addEventListener('click',function(){ setTimeout(add,0); });
  document.addEventListener('change',function(){ setTimeout(add,0); });
  setTimeout(add,400);
  setTimeout(add,1200);
  var rt; window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(add,150); });
})();

/* Landing trust row, pre-:has() fallback (2026-10-01). hf-lp-buy renders a
   trust slot even when its label setting is empty, leaving an icon with no
   text. hf-base.css hides those with :has(); this removes them for older
   browsers that do not support it. Labels are server-rendered, so one pass
   after parse is enough. */
(function(){
  var ls=document.querySelectorAll('.lpb__trust li');
  if(!ls.length) return;
  Array.prototype.forEach.call(ls,function(li){
    var b=li.querySelector('b');
    if(!b || !String(b.textContent||'').trim()){
      if(li.parentNode) li.parentNode.removeChild(li);
    }
  });
})();

/* Colour change resets the gallery to that colour's first photo
   (2026-10-01). The section hides and shows images when the colourway
   changes, but it leaves the phone carousel scrolled wherever it was and
   leaves the thumbnail highlight on whatever index was active. Measured
   on the live page: the strip sat at scrollLeft 1144 — slide three, a
   shared photo — while the hero flag and the highlight were on the grey
   shot, so the big image, the dots and the outlined thumbnail disagreed
   with each other (owner report).

   This puts all three back on the hero after a colour is picked: the
   highlight is matched to the hero by its stamp (the thumbnails carry
   data-mp-gthumb, the images data-hfgi, and the two use the same
   numbering), and the carousel is scrolled back to it, which is what the
   section's own scroll handler reads to repaint the dots. It runs twice,
   after the section's synchronous repaint and again after the gallery
   re-order that follows a colour click, because both move things. */
(function(){
  if(!document.body || document.body.className.indexOf('template-product')<0) return;
  var gal=document.querySelector('[data-mp-gal]');
  if(!gal) return;
  function sync(){
    var hero=gal.querySelector('img.is-hero');
    if(!hero) return;
    var idx=hero.getAttribute('data-hfgi');
    Array.prototype.forEach.call(document.querySelectorAll('.hf-mp__gthumb'),function(b){
      if(idx!==null && b.getAttribute('data-mp-gthumb')===idx) b.classList.add('is-on');
      else b.classList.remove('is-on');
    });
    if(gal.scrollWidth>gal.clientWidth+4){
      var left=Math.max(0, hero.offsetLeft-gal.offsetLeft);
      try{ gal.scrollTo({left:left, behavior:'auto'}); }catch(e){ gal.scrollLeft=left; }
    }
  }
  function onColour(e){
    var t=e.target;
    if(!t || !t.closest) return;
    if(!t.closest('[data-mp-opt="0"]') && !t.closest('.hf-mp__swb') && !t.closest('select[data-mp-stopt="0"]')) return;
    setTimeout(sync,60);
    setTimeout(sync,220);
  }
  document.addEventListener('click',onColour);
  document.addEventListener('change',onColour);
})();
